// extracted by mini-css-extract-plugin
export default {"root":"_1WGba","first-row":"_2cXRT","firstRow":"_2cXRT","second-row":"_2v2WO","secondRow":"_2v2WO"};